import { AfterViewInit, Component, OnInit } from '@angular/core';
import { IDoaCategory } from '../../../interface/administrator/admin'; 
import { ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { AdminService } from '../../../services/administrator/admin.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { AddUpdateDialogComponent } from './add-update-dialog/add-update-dialog/add-update-dialog.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../shared/module/material.module';
import { SharedServices } from '../../../shared/services/shared.services';
import { ConfirmdialogComponent } from '../../../shared/component/confirmdialog/confirmdialog.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-doa-categories',
  imports: [CommonModule,MaterialModule],
  templateUrl: './doa-categories.component.html',
  styleUrl: './doa-categories.component.css'
})
export class DoaCategoriesComponent implements OnInit, AfterViewInit {
  title = 'DOA Categories Setup';
  isLoading:boolean=false;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  DisplayedColumns: string[] = [
    'serialNo',
    'catCode',
    'catName',
    'description',
    'delegated',
    'actions'
  ];
  excelData: any;
  dataSource = new MatTableDataSource<IDoaCategory>();
  constructor(private http: HttpClient, private sharedService:SharedServices, private adminservice: AdminService, public dialog: MatDialog) { }
  ngOnInit(): void {
    this.isLoading = true;
    this.getDoaCategory();
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  getDoaCategory(): Observable<IDoaCategory[]> {
    this.adminservice.getDoaCategory()
      .subscribe((data: any) => {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.isLoading = false;
        this.excelData = this.dataSource.data.map((item, index) => ({
          ...item,
          'S/No': index + 1,
          'Category Code': item.catCode,
          'Category Name': item.catName,
          'Description': item.catTitle ?? '',
          'Can be Delegated': item.delegated ?? ''
        }));
      }, error => {
        console.error('Error fetching categories', error);
        this.isLoading = false;
      });
      return this.adminservice.getDoaCategory(); 
  }
  openAddDialog(): void {
    const dialogRef = this.dialog.open(AddUpdateDialogComponent, {
      width: '400px',
      height: '450px',
      data: { isEdit: false, existingCategories: this.dataSource.data },
      panelClass: 'custom-dialog-container'
    });
  
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.getDoaCategory();
    });
  }
    openUpdateDialog(element: IDoaCategory): void {
      const dialogRef = this.dialog.open(AddUpdateDialogComponent, {
        width: '400px',
        height: '450px',
        data: { isEdit: true, user: element, existingCategories: this.dataSource.data },
        panelClass: 'custom-dialog-container'
      });
    
      dialogRef.afterClosed().subscribe((result) => {
        if (result) this.getDoaCategory();
      });
    }

    removeCategory(element: IDoaCategory): void {
      const dialogRef = this.dialog.open(ConfirmdialogComponent, {
        width: 'auto',
        position: { top: '1'},
      data: { message: 'Are you sure you want to delete the category?' }
      });
    
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.isLoading = true;
          this.adminservice.deleteDoaCategory(element.id).subscribe({
            next: response => {
              this.getDoaCategory().subscribe({
                next: () => {
                  this.sharedService.openModal('Message', 'Removed Successfully');
                  this.isLoading = false;
                },
                error: error => {
                  console.error('Error fetching categories', error);
                  this.isLoading = false;
                }
              });
            },
            error: error => {
              console.error('Error removing category', error);
              this.isLoading = false;
            }
          });
        }
      });
    }
  applyFilter(event: Event, column: string): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filterPredicate = (data: IDoaCategory, filter: string) => {
      const filters = JSON.parse(filter);
      return Object.keys(filters).every(key => {
        const textToSearch = data[key as keyof IDoaCategory] && data[key as keyof IDoaCategory].toString().toLowerCase() || '';
        return textToSearch.indexOf(filters[key]) !== -1;
      });
    };
  
    const currentFilters = this.dataSource.filter ? JSON.parse(this.dataSource.filter) : {};
    currentFilters[column] = filterValue;
    this.dataSource.filter = JSON.stringify(currentFilters);
  
    const filteredData = this.dataSource.filteredData.map((item, index) => ({
      ...item,
      'S/No': index + 1,
      'Category Code': item.catCode,
      'Category Name': item.catName,
      'Description': item.catTitle ?? '',
      'Can be Delegated': item.delegated ?? ''
    }));
    this.excelData = filteredData;
  }
  downloadExcel(): void {
    this.adminservice.getDoaCategoryWorksheet(this.excelData).subscribe(
      (data:Blob) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `DoaCategory_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error => {
        console.error('Error downloading the file', error);
      }
    );
  }

}
